import { uiRows } from './types-def.js';
/** `web/catalogue` (1.N-2): per-type tables whose state lives in the typed URL. */
export const CATALOGUE_INTERACTIONS = uiRows([
    {
        id: 'catalogue.url.filter',
        module: 'web/catalogue',
        behavior: 'The filter survives reload, back and forward through the URL',
        owner: '1.N-2',
        since: 'exit-1b',
    },
    {
        id: 'catalogue.url.sort',
        module: 'web/catalogue',
        behavior: 'The sort survives reload, back and forward through the URL',
        owner: '1.N-2',
        since: 'exit-1b',
    },
    {
        id: 'catalogue.url.columns',
        module: 'web/catalogue',
        behavior: 'The column choice survives reload, back and forward through the URL',
        owner: '1.N-2',
        since: 'exit-1b',
    },
    {
        id: 'catalogue.url.bad-params',
        module: 'web/catalogue',
        behavior: 'Bad URL parameters fall back to the defaults without an error page',
        owner: '1.N-2',
        since: 'exit-1b',
    },
]);
//# sourceMappingURL=catalogue.js.map